import type { SlaRankingRowVM } from '../../view-models';
import type React from 'react';

export function SlaRankingTable({
  rows,
  mainLabel = 'Violações 30d',
  shortLabel = 'Violações 7d',
}: {
  rows: SlaRankingRowVM[];
  mainLabel?: string;
  shortLabel?: string;
}): React.JSX.Element {
  return (
    <table className="sla-ranking">
      <thead>
        <tr>
          <th>Posição</th>
          <th>Operador</th>
          <th className="num">{mainLabel}</th>
          <th className="num">{shortLabel}</th>
          <th className="num">Tendência</th>
        </tr>
      </thead>
      <tbody>
        {rows.length === 0 ? (
          <tr>
            <td colSpan={5}>Nenhuma violação de SLA atribuída no período.</td>
          </tr>
        ) : (
          rows.map((r) => (
            <tr key={r.userId} className={r.atRisk ? 'at-risk' : ''}>
              <td>
                <b>#{r.rank}</b>
              </td>
              <td>{r.name}</td>
              <td className="num">
                <b>{r.monthly30d}</b>
              </td>
              <td className="num">{r.weekly7d}</td>
              <td className="num">
                {r.trend === 'up' ? '↗ atenção' : r.trend === 'down' ? '↘' : '→'}
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
}
